import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=3033acb2&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports